import script from "./AboutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=js"

import "../css/general-style.css?vue&type=style&index=0&lang=css&external"
import "../css/aboutStyle.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__